module.exports = __webpack_public_path__ + "static/directory_2-98aa994180cf96998fca7c36f07d0e89.png";